import ForumCategoriesList from "../../components/forums/ForumCategoriesList"

export const ForumsPages = () => {

    return (
        <ForumCategoriesList></ForumCategoriesList>
    )
}